import React, { Component } from 'react'
import {
  VictoryChart,
  VictoryTheme,
  VictoryZoomContainer,
  VictoryTooltip,
  VictoryStack,
  VictoryArea,
  VictoryAxis,
  VictoryLegend
} from 'victory'
import { RED_YELLOW_BLUE } from '../theme/colors'
// import { format } from 'date-fns/esm'

const INTERPOLATION = 'monotoneX'

class StackedAreaChart extends Component {
  constructor (props) {
    super(props)
    const { datetime } = this.props
    this.state = {
      brushDomain: { x: [datetime, datetime + 104000] }
    }
  }

  static defaultProps = {
    handleMouseEnter: () => console.log('mouseenter'),
    handleMouseLeave: () => console.log('mouseleave')
  }


  handleBrush = domain => {
    // this.setState({zoomDomain: domain})
  }

  handleBrushClicked = event => {
    console.log(event.target.nodeName)
    if (event.target.nodeName === 'svg') {
      console.log('stopping propagation')
      event.stopPropagation()
    }
  }

  handleMouseEnter = (event, data) => {
    const { handleMouseEnter } = this.props
    handleMouseEnter(event, data)
  }

  handleMouseLeave = (event, data) => {
    const { handleMouseLeave } = this.props
    handleMouseLeave(event, data)
  }

  handleZoomToObject = (event, data) => {
    console.log('click')
    const { handleZoomToObject } = this.props
    handleZoomToObject(event, data)
  }

  handleClick (event, props) {
    const { setNewTimeRequested } = this.props
    const activePoint = props.activePoints.find(item => item.timestamp)
    if (activePoint && activePoint.timestamp) {
      const timestamp = new Date(activePoint.timestamp).getTime()
      setNewTimeRequested(timestamp, 'Mopra')
    }
  }

  createGroups = (
    data,
    x,
    y,
    groupByFilters,
    datetime,
    uuidsHighlighted,
    chartStyles,
    chartLabels
  ) => {
    // const timestamp = new Date(datetime).toISOString()
    
    const groupedData = groupByFilters.map(filter => data.filter(filter))

    const groups = groupedData.map(data => [
      <VictoryArea
        data={data}
        x={x}
        y={y}
        interpolation={INTERPOLATION}
        events={[
          {
            target: 'data',
            eventHandlers: {
              onMouseEnter: this.handleMouseEnter,
              onMouseLeave: this.handleMouseLeave
            }
          }
        ]}
      />
    ])

    return groups
  }

  render () {
    const {
      data,
      x,
      y,
      groupByFilters,
      datetime,
      uuidsHighlighted,
      chartStyles,
      chartLabels,
      legendCategories=[{name: 'Consolidated'}, {name: 'Non-Consolidated'}, {name: 'Water'}]
          } = this.props

    const groups = this.createGroups(
      data,
      x,
      y,
      groupByFilters,
      datetime,
      uuidsHighlighted,
      chartStyles,
      chartLabels
    )

    return (
      <VictoryChart
        scale={{ x: 'time' }}
        theme={VictoryTheme.material}
        padding={{ bottom: 50, top: 10, left: 45, right: 10 }}
        width={600}
        height={300}
        domain={{ y: [0, 1] }}
        domainPadding={{ x: 10, y: 25 }}
        style={{ parent: { cursor: 'pointer' } }}
        >
        <VictoryAxis dependentAxis tickFormat={t => `${t*100}%`} />
        <VictoryAxis scale={{ x: 'time' }} />
        <VictoryLegend x={125} orientation='horizontal' data={legendCategories} colorScale={RED_YELLOW_BLUE} />
        <VictoryStack colorScale={RED_YELLOW_BLUE}>
          {groups}
        </VictoryStack>
      </VictoryChart>
    )
  }
}
export default StackedAreaChart



// WEBPACK FOOTER //
// ./src/charts/StackedAreaChart.js